import { render, staticRenderFns } from "./BrowserSearchComponentVoice.vue?vue&type=template&id=43e8ad20&scoped=true&"
import script from "./BrowserSearchComponentVoice.vue?vue&type=script&lang=js&"
export * from "./BrowserSearchComponentVoice.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=43e8ad20&prod&scoped=true&lang=css&"
import style1 from "./BrowserSearchComponentVoice.vue?vue&type=style&index=1&id=43e8ad20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e8ad20",
  null
  
)

export default component.exports